import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import HospitalSelect from "../selectFilters/HospitalSelect";
import Select from "react-select";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { HospitalServices } from "../services/HospitalServices";
import { CircularProgress } from "@mui/material";
const AddNewMapping = ({ setOpen, selectedHospitalId }) => {
  const [specialityList, setSpecialityList] = useState(null);
  const [postData, setPostData] = useState(null);
  const [saving, setSaving] = useState(false);
  const handleSave = async () => {
    if (!postData || postData?.length === 0) {
      window.alert("Please select atleast one speciality");
    } else {
      setSaving(true);
      try {
        const res = await HospitalServices?.addHospitalSpecialityMapping(
          postData
        );
        console.log(res?.data);
        window.alert(res?.data?.messeage);
      } catch (error) {
        handleApiErrorResponses(error);
      }
      setSaving(false);
    }
  };
  const getSpecialityList = async () => {
    try {
      const res = await HospitalServices?.getUniqueSpecialityList("", 1, 50);
      console.log("speciality res:", res?.data);
      setSpecialityList(res?.data?.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getSpecialityList();
  }, []);
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-[#017C5780] z-[1203] flex justify-center items-center">
      <div className="relative h-[50%] w-[50%] flex items-center justify-center bg-white rounded-[20px]">
        <div className="absolute top-3 right-2" onClick={() => setOpen(false)}>
          <Close />
        </div>

        <div className="flex flex-col gap-3 h-fit w-[85%]">
          <div className="font-semibold">Select Speciality</div>
          <Select
            isMulti
            isDisabled={!selectedHospitalId}
            options={specialityList}
            getOptionLabel={(options) => options["speciality"]}
            getOptionValue={(options) => options["id"]}
            onChange={(items) => {
              const modifiedData = items?.map((item) => {
                return {
                  hospitalId: selectedHospitalId,
                  specialityId: item?.specialityId,
                  speciality: item?.speciality,
                };
              });
              setPostData(modifiedData);
            }}
          />
          <div className="flex justify-center">
            {saving ? (
              <CircularProgress />
            ) : (
              <div
                className="w-fit text-white text-sm bg-[#017C57] py-3 px-12 rounded-full cursor-pointer mt-4"
                onClick={handleSave}
              >
                SAVE
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewMapping;
